import React from 'react';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { UserCog, LogOut, Eye } from 'lucide-react';

// Fixed bottom bar shown whenever an admin is running a "login as user"
// support session. Lets them return to their admin account in one tap.
// View-only sessions are amber-red and clearly labelled; full sessions amber.
export function ImpersonationBanner() {
    const { impersonating, stopImpersonation } = useAuth();
    if (!impersonating) return null;
    const readonly = !!impersonating.readonly;
    return (
        <div
            className={`fixed bottom-0 inset-x-0 z-[60] shadow-[0_-2px_12px_rgba(0,0,0,0.15)] ${readonly ? 'bg-rose-600 text-white' : 'bg-amber-500 text-amber-950'}`}
            data-testid="impersonation-banner"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 text-sm font-medium min-w-0">
                    {readonly ? <Eye className="h-4 w-4 shrink-0" /> : <UserCog className="h-4 w-4 shrink-0" />}
                    {readonly && (
                        <span className="hidden sm:inline-flex items-center rounded-full bg-white/20 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide shrink-0" data-testid="impersonation-readonly-badge">
                            View-only
                        </span>
                    )}
                    <span className="truncate">
                        {readonly ? 'View-only support session — ' : 'Support mode — '}
                        viewing as <strong>{impersonating.name || impersonating.email}</strong>
                        <span className="hidden sm:inline"> ({impersonating.email})</span>
                    </span>
                </div>
                <Button
                    size="sm"
                    onClick={stopImpersonation}
                    className={`shrink-0 gap-1.5 ${readonly ? 'bg-white text-rose-700 hover:bg-rose-50' : 'bg-amber-950 text-amber-50 hover:bg-amber-900'}`}
                    data-testid="impersonation-exit-button"
                >
                    <LogOut className="h-3.5 w-3.5" /> Exit to admin
                </Button>
            </div>
        </div>
    );
}

export default ImpersonationBanner;
